<template>
  <div class="special-main">
    <div class="wrap">
      <div class="special-content">
        <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title">
              <div class="collapse-title">课程购买</div>
            </template>
            <div class="collapse-list">
              <div
                  class="collapse-item"
                  v-for="item in categoryList"
                  :key="item.id"
              >
                <div class="collapse-item-title">{{ item.cateName }}</div>
                <div class="collapse-item-step">
                  <div v-if="item.isPay === 1" style="color: #67C23A;">已购买</div>
                  <div v-else>购买</div>
                  <el-checkbox
                      v-model="item.checked"
                      :disabled="item.isPay === 1"
                      @change="handleChecked(item)"
                  ></el-checkbox>
                </div>
              </div>
            </div>
            <div class="collapse-btn">
<!--              <el-button-->
<!--                  style="margin-left: 20px"-->
<!--                  type="primary"-->
<!--                  size="small"-->
<!--                  @click="selectSubject"-->
<!--              >一键选课</el-button>-->
              <el-button
                  type="primary"
                  size="small"
                  v-if="checkedList.length > 0"
                  @click="createOrder"
              >确认订单</el-button>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <payModal ref="payModal"></payModal>
    <div class="float-btn" id="scrollToBottomBtn" @click="scrollToBottom">
      <span class="btn-text">课程购买</span>
      <i class="el-icon-bottom"></i> <!-- 使用 Element UI 的下箭头图标 -->
    </div>
  </div>
</template>
<script>
import { getMyCategory } from '@/api/course'
import {createOrder} from "@/api/order";
import payModal from "@/views/payModal";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data() {
    return {
      activeNames: ["1"],
      activeName: 'first',
      value: '',
      radio: 1,
      categoryList:[],
      checkedList: [],
      loading: true
    }
  },
  components:{ payModal },
  created() {
    // 获取我的已购课程
    this.getMyCategory()
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 确认订单
    async createOrder() {
      try {
        if(this.checkedList.length === 0){
          this.$message({
            type: "warning",
            message: "请选择课程！",
          });
          return;
        }
        const res = await createOrder({
          categoryIds: this.checkedList.join(","),
        });
        this.$refs.payModal.open(res.data);
        console.log(res);
      } catch (error) {}
    },
    // 选择课程
    handleChecked() {
      this.checkedList = [];
      this.categoryList.forEach((item) => {
        if (item.checked === true) {
          this.checkedList.push(item.id);
        }
      });
    },
    selectSubject() {
      this.checkedList = [];
      this.categoryList.forEach((item) => {
        // 只选择未购买的课程
        if (item.isPay !== 1) {
          item.checked = true;
          this.checkedList.push(item.id);
        }
      });
      if (this.checkedList.length === 0) {
        this.$message({
          type: "warning",
          message: "没有任何可选新课程！",
        });
      }
      // this.$refs.payModal.dialogVisible = true
    },
    scrollToBottom() {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    },
    //获取所有的专题列表
    async getMyCategory(){
      try {
        const params = {
        }
        const res = await getMyCategory(params)
        this.categoryList = res.data
        this.loading = false
      } catch (error) {
        console.log(error);
      }
    },
  }
}
</script>

<style scoped lang="scss">
.special-main {
  .special-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    height: 56px;
    line-height: 56px;

    .wrap-special {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      img {
        margin-right: 10px;
        width: 25px;
        height: 25px;
      }

      span {
        font-size: 20px;
        color: #1888ff;
      }
    }
  }

  .special-title-area {
    display: flex;
    justify-content: flex-start;
    margin: 76px 0 20px 0;
    padding: 32px;
    background-color: #fff;
    border-radius: 10px;

    .special-title-cover {
      margin-right: 70px;
      width: 30%;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .special-title-infos {
      flex: 1;
      h3 {
        margin: 0;

        font-size: 22px;
        font-weight: 500;
      }
    }

    .special-title-desc {
      padding: 16px;
      margin-top: 16px;
      margin-bottom: 32px;
      background-color: #f5f6f6;
      color: rgba(0, 0, 0, 0.45);
      font-size: 14px;

      div {
        margin-bottom: 16px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 指定显示的行数 */
        overflow: hidden;
      }

      span {
        margin: 4px;
        color: #558ad6;
        cursor: pointer;
      }
    }
  }

  .special-content-tab-title {
    font-size: 16px;
    font-weight: 500;
    padding: 20px 12px;
  }

  .collapse-title {
    width: 100%;
    font-weight: 700;
    font-size: 18px;
    padding: 40px 50px;
  }

  .collapse-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px 40px;

    .collapse-item {
      width: 22%;
      position: relative;
      top: 0;
      margin-right: 20px;
      margin-bottom: 0px;
      background-color: #fff;
      border-radius: 0px;
      overflow: hidden;
      transition: all 0.3s;
      border: 1px solid #e9e9e9;
      margin-bottom: 10px;
      .collapse-item-cover {
        width: 100%;
        height: 128px;
        overflow: hidden;
        position: relative;
        .collapse-item-cover-mark {
          position: absolute;
          top: 8px;
          left: 8px;
          padding: 2px 10px;
          font-size: 12px;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 10;
          border-radius: 4px;
        }
        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }
      }

      .collapse-item-title {
        color: #ffffff;
        background-color: #558ad6; /* 红色背景 */
        padding: 12px 15px; /* 增加内边距，让背景更饱满 */
        margin: 0; /* 移除默认 margin */
        font-size: 16px;
        display: block; /* 改为块级元素，填满父容器 */
        width: 100%; /* 宽度铺满 */
        box-sizing: border-box; /* 确保 padding 不额外增加宽度 */
        text-align: center; /* 文字居中（可选） */
        border-radius: 0; /* 去除圆角（如需直角） */
        cursor: pointer;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }

      .collapse-item-title:hover {
        color: #ffffff;
      }

      .collapse-item-hour {
        span {
          margin: 12px 16px;
          color: #ddab63;
          font-size: 13px;
        }
      }

      .collapse-item-step {
        margin-top: 0px;
        padding: 5px 16px;
        border-top: 1px solid #e9e9e9;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        span {
          color: #558ad6;
        }
      }
    }
    .collapse-item:hover {
      top: -5px;
      cursor: pointer;
    }
  }

  .selBtn {
    width: 20%;
  }

  .collapse-btn {
    display: flex;
    justify-content: flex-end;
    margin-right: 20px;
  }
}
@media (max-width: 600px) {
  .collapse-item {
    width: 46.5% !important;
  }
  .selBtn {
    width: 50% !important;
  }
}

.float-btn {
  position: fixed;
  right: 20px;
  bottom: 20px;
  background-color: #558ad6;
  color: white;
  border-radius: 25px;
  padding: 10px 15px;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  transition: all 0.3s;
}

.btn-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.btn-text {
  font-size: 16px; /* 调小字体 */
  margin-bottom: 4px; /* 文字和图标间距 */
}

.el-icon-bottom {
  font-size: 14px;
}

.float-btn:hover {
  background-color: #4b90bf;
  transform: translateY(-3px);
}
</style>
